import React, { useState, useMemo } from 'react';
import { Badge, Button, Card, CardBody } from 'reactstrap';
import { Link, NavigateFunction } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';
import TableContainer from '../../components/Common/TableContainer';

// Static data aligned with SalesInvoice model
const latestTransaction: Transaction[] = [
  {
    id: 1,
    orderId: '#SI1234',
    billingName: 'Ali Khan',
    orderDate: '04 Aug, 2025',
    total: 'PKR 1500',
    paymentStatus: 'Paid',
    paymentMethod: 'Cash',
  },
  {
    id: 2,
    orderId: '#SI1235',
    billingName: 'Sana Ahmed',
    orderDate: '03 Aug, 2025',
    total: 'PKR 2200',
    paymentStatus: 'Pending',
    paymentMethod: 'Visa',
  },
  {
    id: 3,
    orderId: '#SI1236',
    billingName: 'Dr. Omar Farooq',
    orderDate: '02 Aug, 2025',
    total: 'PKR 1800',
    paymentStatus: 'Paid',
    paymentMethod: 'Paypal',
  },
  {
    id: 4,
    orderId: '#SI1237',
    billingName: 'Fatima Zia',
    orderDate: '01 Aug, 2025',
    total: 'PKR 3000',
    paymentStatus: 'Refund',
    paymentMethod: 'Cash',
  },
];

// Define interfaces
interface Transaction {
  id: number;
  orderId: string;
  billingName: string;
  orderDate: string;
  total: string;
  paymentStatus: 'Paid' | 'Pending' | 'Refund';
  paymentMethod: 'Mastercard' | 'Visa' | 'Paypal' | 'Cash';
}

interface Column {
  header: string | (() => JSX.Element);
  accessorKey: string;
  enableColumnFilter: boolean;
  enableSorting: boolean;
  cell?: (cellProps: { row: { original: Transaction } }) => JSX.Element;
}

interface WithRouterProps {
  navigate: NavigateFunction;
}

const LatestTransaction: React.FC<WithRouterProps> = () => {
  const [modal1, setModal1] = useState<boolean>(false);

  const toggleViewModal = () => setModal1(!modal1);

  const columns: Column[] = useMemo(
    () => [
      {
        header: () => <input type="checkbox" className="form-check-input" />,
        accessorKey: 'id',
        enableColumnFilter: false,
        enableSorting: true,
        cell: () => <input type="checkbox" className="form-check-input" />,
      },
      {
        header: 'Invoice ID', // Updated header to reflect pharmacy context
        accessorKey: 'orderId',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => (
          <Link to="#" className="text-body fw-bold">
            {cellProps.row.original.orderId}
          </Link>
        ),
      },
      {
        header: 'Customer Name', // Updated header
        accessorKey: 'billingName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Sale Date', // Updated header
        accessorKey: 'orderDate',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Total',
        accessorKey: 'total',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Payment Status',
        accessorKey: 'paymentStatus',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => (
          <Badge
            className={`font-size-11 badge-soft-${
              cellProps.row.original.paymentStatus === 'Paid'
                ? 'success'
                : cellProps.row.original.paymentStatus === 'Refund'
                ? 'warning'
                : 'danger'
            }`}
          >
            {cellProps.row.original.paymentStatus}
          </Badge>
        ),
      },
      {
        header: 'Payment Method',
        accessorKey: 'paymentMethod',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => (
          <span>
            <i
              className={
                cellProps.row.original.paymentMethod === 'Paypal'
                  ? 'fab fa-cc-paypal me-1'
                  : cellProps.row.original.paymentMethod === 'Cash'
                  ? 'fas fa-money-bill-alt me-1'
                  : cellProps.row.original.paymentMethod === 'Mastercard'
                  ? 'fab fa-cc-mastercard me-1'
                  : cellProps.row.original.paymentMethod === 'Visa'
                  ? 'fab fa-cc-visa me-1'
                  : ''
              }
            />
            {cellProps.row.original.paymentMethod}
          </span>
        ),
      },
      {
        header: 'View Details',
        accessorKey: 'view',
        enableColumnFilter: false,
        enableSorting: false, // Sorting not needed for action buttons
        cell: () => (
          <Button
            type="button"
            color="primary"
            className="btn-sm btn-rounded"
            onClick={toggleViewModal}
          >
            View Details
          </Button>
        ),
      },
    ],
    [],
  );

  return (
    <React.Fragment>
      {/* <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} /> */}
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">Latest Sales</div> {/* Updated title */}
          <TableContainer
            columns={columns}
            data={latestTransaction}
            isGlobalFilter={false}
            tableClass="align-middle table-nowrap mb-0"
            theadClass="table-light"
          />
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default withRouter(LatestTransaction);
